const PrimaryHost = (process.env.REACT_APP_ENV === "development" ? 
  "localhost:3000" : "www.adamsmith.haus")


export const Domains = {
  PrimaryHost,
  // Help: "help." + PrimaryHost,
  // WWW: "www." + PrimaryHost,
  WWW: PrimaryHost,
  // DocsAPI: "https://alpha.kite.com",
  // DocsAPI: "http://localhost:9090",
  DocsAPI: "https://docsapi.adamsmith.dev",
  // DocsAPI: "http://54.177.18.230",
  DisableHTTPS: (process.env.REACT_APP_ENV === "development")
}